<template>
  <div>
    <mini-cart-item v-for="(item, index) in $props.cartData.entries"
                    :entries="item"
                    :key="index"/>
  </div>
</template>

<script>
import MiniCartItem from '@/components/mini-cart/mini-cart-item'

export default {
  name: 'mini-cart-items',
  components: { MiniCartItem },
  props: {
    cartData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style scoped>

</style>
